import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ServiceOrdersCard } from "./ServiceOrdersCard";
import { MeetingsCard } from "./MeetingsCard";
import { InvoicesCard } from "./InvoicesCard";
import { SupportTicketsCard } from "./SupportTicketsCard";
import { DisputesCard } from "./DisputesCard";
import { WelcomeBanner } from "@/components/portal/WelcomeBanner";

const WELCOME_DISMISSED_KEY = "echopeak_welcome_dismissed";

export function OverviewPage() {
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(WELCOME_DISMISSED_KEY);
    if (!dismissed) {
      setShowWelcome(true);
    }
  }, []);

  const handleWelcomeDismiss = () => {
    localStorage.setItem(WELCOME_DISMISSED_KEY, "true");
    setShowWelcome(false);
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      {showWelcome && <WelcomeBanner onDismiss={handleWelcomeDismiss} />}

      <div className="mb-8">
        <h1 className="font-display text-3xl font-bold mb-2">Overview</h1>
        <p className="text-muted-foreground">
          Welcome back — here's a snapshot of your activity.
        </p>
      </div>

      <div className="space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ServiceOrdersCard />
          <MeetingsCard />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <InvoicesCard />
          <SupportTicketsCard />
          <DisputesCard />
        </div>
      </div>
    </motion.div>
  );
}
